import { Component, ViewEncapsulation, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { AccountService, EventManager } from 'src/app/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { QueryParams } from './shared/model/query.params.model';
import { UsersService } from './modules/users/users.service';
import { LoginService } from './core/services';
import { AppQueries, Dispatcher, StoreInfoUser, StoreResource } from './state';
import { ThemeService } from './shared/services/theme.service';
import { Constant } from './core/constant';
import { Subscription } from 'rxjs';
declare let $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [TranslateService]
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  title = 'crm-fmarket';
  spinner: number = 0;
  transactions: any[] =[];
  totalTransactions: any;
  totalSupport: any;
  myInterval: any;
  ignoreApi: any[] = [];
  noLoadingApi: any[] = [];
  isShowSpinner: boolean = false;
  theme: string = 'default';
  cssContent: string = '';
  subscriptions?: Subscription[] = [];
  userProfile: any;
  constructor(
    private translate: TranslateService,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private sessionStorageService: SessionStorageService,
    private localStorageService: LocalStorageService,
    private accountService: AccountService,
    private loginService: LoginService,
    public toast: ToastrService,
    public usersService: UsersService,
    private themeService: ThemeService,
    public dispatcher: Dispatcher,
    private appQueries: AppQueries,
    private eventManager: EventManager) {
      translate.addLangs(['en_US', 'vi_VN']);
      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang('vi_VN');
      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use('vi_VN');
    }
  ngOnInit() {
    this.subscriptions = [
      this.appQueries.userProfile$
      .subscribe((userProfile) => {
        this.userProfile = userProfile || {};
        if (this.userProfile.id) {
          this.dispatcher.fire(new StoreResource());
          this.loadTransactions();
          this.summaryForeignInvestor();
        }
      }),
    ]
    this.changeTheme(this.localStorageService.retrieve('theme'));
    this.initIgnorepis();
    this.initApiNoLoading();
    this.eventManager.subscribe('show-spinner', (res) => {
      if (!this.isShowSpinner) {
        this.isShowSpinner = true;
        console.log('show spinner');
        setTimeout(() => {
          this.spinnerService.show();  
        }, 100)
      }
    });
    this.eventManager.subscribe('close-spinner', (res) => {
      if (this.isShowSpinner) {
        this.isShowSpinner = false;
        this.spinner = 0;
        console.log('close spinner');
        setTimeout(() => {
          this.spinnerService.hide();  
        }, 1000)
      }
    });
    this.eventManager.subscribe('Fmarket.authenError' , (content) => {
      this.router.navigate(['/authentication/login']);
    });
    this.eventManager.subscribe('Fmarket.httpError' , (content) => {
      if (!this.ignoreError(content.content.url || '')) {
        this.toast.error(content.content.error.message || content.content.error.status || 'Đang có lỗi xảy ra!');
      }
    
    });
    if (this.loginService.getToken()) {
      this.dispatcher.fire(new StoreInfoUser(this.localStorageService.retrieve('profile')));
    }
    this.eventManager.subscribe('login-success' , (content) => {
      
    });
    this.eventManager.subscribe('change-theme' , (res) => {
      this.changeTheme(res.content.theme);
    });
    this.myInterval = setInterval(() => {
      if (this.loginService.getToken()) {
        this.loadTransactions();
      }
    }, 60 * 1000);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      const acc = this.sessionStorageService.retrieve('USER_PROFILE');
      if (acc) {
        if (acc.adminGroup.name === 'Sale Lead') {
          acc.isSaleLead = true;
        }
        this.accountService.authenticate(acc);
      }
    }, 1000);
    $('body').on('click', (e) => {
      this.eventManager.broadcast({
        name: 'body-click',
        content: {
          event: e
        }
      })
    });
  }
  ngOnDestroy() {
    clearInterval(this.myInterval);
  }
  loadTransactions(): void  {
    const queryParams = new QueryParams();;
    this.transactions = [];
    queryParams.searchParams.typeCodes = ['SELL'];
    queryParams.searchParams.crmResponsibleStaffCode =  this.userProfile.isSaleLead ? undefined : this.userProfile.account;
    this.usersService
      .queryOrderPending(queryParams)
      .subscribe(
        (res: any) => {
          if (!res.body) {
            return;
          }
          this.transactions = (res.body.data.list || []).map((item) => {
            item.agent = item.agentId || {}; 
            item.type = item.typeId || {};
            item.owner = item.ownerId || {};
            item.investmentProfile = item.investmentProfileId || {};
            item.status  = item.statusId || {};
            return item;
          });
          this.totalTransactions = res.body.data.total || 0;
          this.eventManager.broadcast({
            name: 'get-transactions',
            content: {
              transactions: this.transactions,
              total: this.totalTransactions
            }
          });
          this.sessionStorageService.store('transactions', this.transactions);
          this.sessionStorageService.store('totalTransactions', this.totalTransactions);
        },
      );
      
      this.usersService
      .querySupportStatusSummary(queryParams)
      .subscribe(
        (res: any) => {
          if (!res.body) {
            return;
          }
          this.totalSupport = res.body.data.total || 0;
          this.eventManager.broadcast({
            name: 'get-support-list',
            content: {
              totalSupport: this.totalSupport
            }
          });
          this.sessionStorageService.store('totalSupport', this.totalSupport);
        },
      );
  }
  summaryForeignInvestor() {
    this.usersService
      .queryForeignInvestorSummary({})
      .subscribe(
        (res: any) => {
          if (!res.body) {
            return;
          }
          const total = res.body.data.total || 0;
          this.eventManager.broadcast({
            name: 'get-total-foreign-investor',
            content: {
              total
            }
          });
          this.sessionStorageService.store('totalForeignInvestor', total);
        },
      );
  }
  initIgnorepis() {
    this.ignoreApi = [
      'downloadContract',
    ];
  }
  ignoreError(url) {
    return this.ignoreApi.some((api) => url.includes(api));
  }
  initApiNoLoading() {
    this.noLoadingApi = [
      {url: 'vi_VN.json', method: 'GET'},
      {url: 'res/all', method: 'GET'},
      {url: 'user/list-support/summary', method: 'POST'},
      {url: 'order/list', method: 'POST'},
      {url: 'order/pending/filter', method: 'POST'},
      {url: 'api/admin', method: 'GET'},
      {url: 'api/crmStatus', method: 'GET'},
      {url: 'resource/products', method: 'POST'},
      {url: 'resource/all', method: 'GET'},
      {url: 'summary', method: 'POST'},
    ];
    sessionStorage.setItem('noLoadingAPIs', JSON.stringify(this.noLoadingApi));
  }
  changeTheme(theme) {
    theme = theme || 'default';
    this.theme = theme;
    this.localStorageService.store('theme', theme);
    this.themeService.changeTheme(theme);
  }
}
